// extracted by mini-css-extract-plugin
export default {"container_medium":"orders_container_medium__tGO3M","container_large":"orders_container_large__Sa4rW","title":"orders_title__WXknF"};